import { useGetArtefactScope } from '@modules/common/hooks';
import { useEffect, useMemo } from 'react';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';
import { useGetUser } from 'v2/core/services/user';
import { DRAFT_DASHBOARD } from '../constants';
import {
  getEmojiFromDashboard,
  getShortMetadataForDashboard,
} from '../helpers';
import { DashboardActionType } from '../store/dashboardActionType';
import { useDashboardStore } from '../store/useDashboardStore';

export const useUpdateStoreForNewDashboard = () => {
  const { savedSlug } = useParseSavedSlugInfo();
  const dispatch = useDashboardStore(({ dispatch }) => dispatch);
  const user = useGetUser();
  const artefactScope = useGetArtefactScope();

  const shortMetadata = useMemo(
    () =>
      getShortMetadataForDashboard({
        dashboardEmoji: getEmojiFromDashboard(DRAFT_DASHBOARD),
      }),
    [],
  );

  useEffect(() => {
    if (savedSlug) {
      return;
    }

    const draftDashboard = {
      ...DRAFT_DASHBOARD,
      createdBy: user,
      tenantID: user.tenant.id,
      shortMetadata,
      scope: artefactScope,
      createdAt: Math.floor(Date.now() / 1000),
    };

    dispatch({
      type: DashboardActionType.SET_DASHBOARD,
      payload: draftDashboard,
    });
  }, [savedSlug, shortMetadata, user, artefactScope, dispatch]);
};
